module.exports = __webpack_public_path__ + "static/img/home_type_icon_xyzd.a8374a3e.webp";